import React from "react";
import * as Reactstrap from "reactstrap";
import useLoadingIndicatorStyles from "./styles";
import { SetVfxLoadingIndicatorProps, VfxLoadingIndicatorProps } from "./vfxLoadingIndicatorProps";

export const LoadingIndicator: React.FC<VfxLoadingIndicatorProps> = (props) => {
    SetVfxLoadingIndicatorProps(props);

    const loadingIndicatorStyles = useLoadingIndicatorStyles();
    return (
        <div
            style={{
                ...(props.isFullPage ? loadingIndicatorStyles.container : {}),
            }}
        >
            <Reactstrap.Spinner style={props.style} size={props.size} color="secondary"></Reactstrap.Spinner>
        </div>
    );
};